export default __webpack_public_path__ + "static/media/yealink-t53.9cb27276.jpg";